import {LitElement, html, css} from 'lit';

/**
 * Comment Element
 */
export class CommentActionElement extends LitElement {
    static get styles() {
        return css`
            .comment__button, .comment__button:hover, .comment__button:visited {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: var(--link-color,#A89368);
                text-decoration: none;
                margin-left: 0.3em;
            }
            .comment__button__icon {
                width: 15px;
                height: 15px;
            }
            .comment__button__text {
                margin-left: 0.3em;
            }
            .comment__button__count {
                margin-left: 0.3em;
            }
        `;
    }
    

    static get properties() {
        return {
           comment_id: {type: Number},
           actionType: {type: String},
           actionCount: {type: String},
        };
    }

    constructor() {
        super();
        this.comment_id = 0;
        this.actionType = '';
        this.actionCount = 0;
    }

    getActionTypeURL() {
        if (this.actionType == 'delete') {
            return '/comments/delete/' + this.comment_id + '/';
        }
        if (this.actionType == 'reply') {
            return '/comments/reply/' + this.comment_id + '/';
        }
        if (this.actionType == 'flag') {
            return '/comments/flag/' + this.comment_id + '/';
        }
        if (this.actionType == 'like') {
            return '/comments/like/' + this.comment_id + '/';
        }
        if (this.actionType == 'dislike') {
            return '/comments/dislike/' + this.comment_id + '/';
        }

        return '';
    }
    
    getActionTypeIcon() {
        if (this.actionType == 'delete') {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="comment__button__icon">
                <path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" class=""></path>
            </svg>`;
        }

        if (this.actionType == 'reply') {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="reply" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="comment__button__icon">
                <path fill="currentColor" d="M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z" class=""></path>
            </svg>`;
        }

        if (this.actionType == 'flag') {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="flag" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="comment__button__icon">
                <path fill="currentColor" d="M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"></path>
            </svg>`;
        }

        if (this.actionType == 'like') {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="thumbs-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="comment__button__icon">
                <path fill="currentColor" d="M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"></path>
            </svg>`;
        }
        
        if (this.actionType == 'dislike') {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="thumbs-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="comment__button__icon">
                <path fill="currentColor" d="M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"></path>
            </svg>`;
        }


        return html``;
    }

    getActionTypeText() {
        if (this.actionType == 'delete') {
            return 'Delete';
        }
        if (this.actionType == 'reply') {
            return 'Reply';
        }

        return '';
    }

    getActionTypeTitle() {
        if (this.actionType == 'delete') {
            return 'Delete this comment';
        }
        if (this.actionType == 'reply') {
            return 'Reply to this comment';
        }
        if (this.actionType == 'flag') {
            return 'Flag this comment';
        }
        if (this.actionType == 'like') {
            return 'Like this comment';
        }
        if (this.actionType == 'dislike') {
            return 'Dislike this comment';
        }
    }

    getActionTypeCount() {
        if (this.actionCount > 0) {
            return html`<span class="comment__button__count">${this.actionCount}</span>`;
        }
    }

    clickAction(e) {
        e.preventDefault();
        if (this.actionType === 'flag') {
            // Trigger an "are you sure" alert. If the alert is confirmed, follow the link.
            if (confirm('Are you sure you want to report this comment for abuse?')) {
                window.location = this.getActionTypeURL();
                return;
            }
        }
        window.location = this.getActionTypeURL();
    }

    render() {
        return html`<a href="#" class="comment__button" title="${this.getActionTypeTitle()}" @click="${this.clickAction}">
            ${this.getActionTypeIcon()}
            ${this.getActionTypeCount()}
            <span class="comment__button__text">${this.getActionTypeText()}</span>
        </a>`;
    } 
}


window.customElements.define('comment-action-element', CommentActionElement);